import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SubstationTemplateDto } from '../../../models/network-structure.model';
import { SubstationTemplateService } from '../../../services/substation-template.service';
import { CimSubstationService } from '../../../services/cim-substation.service';
import { UtilitySharedService } from '../../../services/shared/utility-shared.service';
import { ToastrService } from 'ngx-toastr';
import { SelectOptionDto } from '../../../models/keyValueItem.model';
import { AcLineSegmentType } from '../../../models/ac-line-segment.model';
import { AcLineSegmentService } from '../../../services/ac-line-segment.service';

export enum SchematicFilterTabType {
    Substations = 'Substations',
    ACLineSegment = 'AC Line Segment'
}

@Component({
  selector: 'lib-adv-map-schematic-filter',
  standalone: false,
  templateUrl: './adv-map-schematic-filter.component.html',
  styleUrl: './adv-map-schematic-filter.component.scss'
})
export class AdvMapSchematicFilterComponent implements OnInit {
  @Output() cimSubstationClicked = new EventEmitter<number>();
  @Output() acLineClicked = new EventEmitter<number>();
  schematicTabs = Object.values(SchematicFilterTabType);
  selectedSchematicFilterTabType: SchematicFilterTabType = SchematicFilterTabType.Substations;
  utilityId: number = 0;

  //overview 
  selectedFilterType: string = 'Select an asset';
  selectedInstance: string = '';
  isFilterVisible = false;

  //substations
  substationTemplates: SubstationTemplateDto[] = [];
  selectedSubstationTemplate: SubstationTemplateDto | null = null;
  cimSubstationSearchText: string = '';
  cimSubstations: any[] = [];
  cimSubstationsForSelect: SelectOptionDto[] = [];

  //ac line segments
  AcLineSegmentType = AcLineSegmentType;
  acLineSegmentTypes: { id: number; name: string; }[] = [
    { id: AcLineSegmentType.Main, name: 'Main\nAC Line'},
    { id: AcLineSegmentType.Incomer, name: 'Incomer\nAC Line'},
    { id: AcLineSegmentType.Primary, name: 'Primary\nAC Line'},
    { id: AcLineSegmentType.Boundary, name: 'Boundary\nAC Line'},
    { id: AcLineSegmentType.Secondary, name: 'Secondary\nAC Line'},
  ]
  selectedAcLineSegmentType: any | null = null;
  acLineSegmentsByType: any[] = [];
  acLineSegmentSearchText: string = '';
  acLineSegmentsForSelect: SelectOptionDto[] = [];

  constructor(private substationTemplateService: SubstationTemplateService,
    private cimSubstationService: CimSubstationService,
    private acLineSegmentService: AcLineSegmentService,
    private utilitySharedService: UtilitySharedService,
    private toastr: ToastrService,
  ) { 
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnInit(): void {
    this.getSubstationTemplates();
  }

  getSubstationTemplates() {
    this.substationTemplateService.getAll(this.utilityId).subscribe({
      next: (response: any) => {
        if (response?.body?.status === 200 || response?.body?.status === 'OK') 
          this.substationTemplates = response?.body?.data || [];
      },
      error: (error: any) => {
        this.toastr.error('Error occurred while fetching substation templates');
      }
    });
  }

  selectSchematicTab(item: string){
    this.selectedSchematicFilterTabType = item as SchematicFilterTabType;
  }

  selectSubstationTemplateFilter(ss: SubstationTemplateDto) {
    this.selectedSubstationTemplate = ss;
    this.selectedFilterType = ss.className;
    this.selectedInstance = '';
    this.cimSubstationService.getAllForSelectMap({ templateId: ss.id!, searchTerm: this.cimSubstationSearchText, isForMap: false }).subscribe({
      next: (response: any) => {
        if (response?.body?.status === 200 || response?.body?.status === 'OK') {
          this.cimSubstations = response?.body?.data || [];
          this.cimSubstationsForSelect = this.cimSubstations.map(x => {
            return {
              id: x.substationTemplateInstanceId,
              name: x.name,
              checked: false
            };
          });
        }  
      }
    });
  }

  get filteredCimSubstations(): SelectOptionDto[] {
    if (!this.cimSubstationSearchText) {
      return this.cimSubstationsForSelect;
    }

    const search = this.cimSubstationSearchText.toLowerCase();
    return this.cimSubstationsForSelect.filter(ss => ss.name.toLowerCase().includes(search));
  }

  get filteredAcLineSegments(): SelectOptionDto[] {
    if (!this.acLineSegmentSearchText) {
      return this.acLineSegmentsForSelect;
    }

    const search = this.acLineSegmentSearchText.toLowerCase();
    return this.acLineSegmentsForSelect.filter(ss => ss.name.toLowerCase().includes(search));
  }

  getSelectedCimSubstationSchematic(item: SelectOptionDto) {
    this.selectedInstance = item.name;
    this.cimSubstationClicked.emit(item.id);
  }

  getSelectedAcLineSegmentSchematic(item: SelectOptionDto){
    this.selectedInstance = item.name;
    this.acLineClicked.emit(item.id);
  }

  selectAcLineTypeForFilter(lineType: any){
    this.selectedAcLineSegmentType = lineType;
    this.selectedFilterType = lineType.name;
    this.selectedInstance = '';
    this.acLineSegmentService.getAllForSelectMap({ acLineType: lineType.id, searchTerm: this.acLineSegmentSearchText }).subscribe({
      next: (response: any) => {
        if (response?.body?.status === 200 || response?.body?.status === 'OK') {
          this.acLineSegmentsByType = response?.body?.data || [];
          this.acLineSegmentsForSelect = this.acLineSegmentsByType.map(x => {
            return {
              id: x.id,
              name: x.name,
              checked: false
            };
          });
        }  
      }
    });
  }

  closeSchematicFilter(){
    this.isFilterVisible = false;
  }

  toggleFilter() {
    this.isFilterVisible = !this.isFilterVisible;
  }
}
